module.exports = __webpack_public_path__ + "img/20200613_142056.20ffc76b.jpg";